/**
 * @deprecated Import from '@/components/atoms' or '@/atoms' instead.
 * This file is kept for backwards compatibility during migration.
 */

export { Button, buttonVariants } from '@/components/atoms/buttons';
export type { ButtonProps } from '@/components/atoms/buttons';
